import type { Map } from "../../../types/content";

interface MapDimensions {
  width: number;
  height: number;
}

export function getStaticMapSrc(
  { width, height }: MapDimensions,
  { location, zoom }: Map,
) {
  return `https://maps.vgc.no/api/maps/basic/static/${location.lon},${location.lat},${zoom}/${width}x${height}.png?markers=${location.lon},${location.lat},teal`;
}
